/**
 * Raised while the model is drawing onto the canvas, so the reverse sync skips those writes.
 * A counter, not a flag: the renderer builds images, videos and groups asynchronously, and until
 * the last one lands the canvas is only part of the model — reading it back would drop the rest.
 */
let depth = 0;

export const applyGuard = {
  get isApplying(): boolean {
    return depth > 0;
  },
  begin(): void {
    depth += 1;
  },
  end(): void {
    depth = Math.max(0, depth - 1);
  }
};
